import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { API, opts, EQUIPMENT_SOURCES } from './equipmentMeta';

const FIELDS = [['brand', 'Manufacturer'], ['model', 'Model'], ['serial', 'Serial'], ['install_date', 'Install date'], ['warranty_until', 'Warranty until'], ['location', 'Location'], ['notes', 'Notes']];

// Technician fixes a Sent Back entry and resubmits it (history is kept server-side).
export const EquipmentResubmitDialog = ({ asset, onClose, onDone }) => {
  const [f, setF] = useState(() => Object.fromEntries([...FIELDS.map(([k]) => [k, asset?.[k] || '']), ['equipment_source', asset?.equipment_source || 'unknown']]));
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  if (!asset) return null;
  const submit = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/field/equipment/${asset.id}/resubmit`, { edits: f, note }, opts);
      toast.success('Resubmitted for approval');
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || 'Resubmit failed'); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#141414] border-[#262626] text-white max-w-md max-h-[90vh] overflow-y-auto" data-testid="equip-resubmit-dialog">
        <DialogHeader><DialogTitle>Fix & Resubmit</DialogTitle></DialogHeader>
        {asset.review_note && <p className="text-xs text-orange-300 bg-orange-500/10 border border-orange-500/40 rounded p-2" data-testid="equip-resubmit-office-note">Office: {asset.review_note}</p>}
        <div className="grid grid-cols-2 gap-2">
          {FIELDS.map(([k, l]) => (
            <div key={k} className={k === 'notes' ? 'col-span-2' : ''}>
              <Label className="text-[10px] text-[#737373] uppercase">{l}</Label>
              <Input type={k.includes('date') || k === 'warranty_until' ? 'date' : 'text'} value={f[k]} data-testid={`equip-resubmit-${k}`}
                onChange={(e) => setF({ ...f, [k]: e.target.value })} className="bg-[#0A0A0A] border-[#262626] text-white h-9" />
            </div>
          ))}
        </div>
        <div className="flex flex-wrap gap-1.5">
          {EQUIPMENT_SOURCES.map((s) => (
            <button type="button" key={s.key} data-testid={`equip-resubmit-source-${s.key}`} onClick={() => setF({ ...f, equipment_source: s.key })}
              className={`px-2.5 py-1 rounded-full text-[11px] border ${f.equipment_source === s.key ? 'bg-[#D4AF37] text-black border-[#D4AF37]' : 'border-[#262626] text-[#A3A3A3]'}`}>{s.label}</button>
          ))}
        </div>
        <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="What did you fix? (optional)" data-testid="equip-resubmit-note" className="bg-[#0A0A0A] border-[#262626] text-white h-9" />
        <Button data-testid="equip-resubmit-submit" disabled={busy} onClick={submit} className="bg-[#D4AF37] text-black hover:bg-[#F3E5AB]">Resubmit</Button>
      </DialogContent>
    </Dialog>
  );
};

export default EquipmentResubmitDialog;
